var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsisV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5C2.8125 5.5 3.5 6.1875 3.5 7C3.5 7.84375 2.8125 8.5 2 8.5C1.15625 8.5 0.5 7.84375 0.5 7C0.5 6.1875 1.15625 5.5 2 5.5ZM0.5 2.25C0.5 1.4375 1.15625 0.75 2 0.75C2.8125 0.75 3.5 1.4375 3.5 2.25C3.5 3.09375 2.8125 3.75 2 3.75C1.15625 3.75 0.5 3.09375 0.5 2.25ZM0.5 11.75C0.5 10.9375 1.15625 10.25 2 10.25C2.8125 10.25 3.5 10.9375 3.5 11.75C3.5 12.5938 2.8125 13.25 2 13.25C1.15625 13.25 0.5 12.5938 0.5 11.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisV);
export default __webpack_public_path__ + "static/media/ellipsis-v.c6081a50e66fb82631b6b2c31e7801a3.svg";
export { ForwardRef as ReactComponent };